









import { Component, Vue } from "vue-property-decorator";

import MainHeader from "../components/MainHeader.vue";
import MainFooter from "../components/MainFooter.vue";
import ElInput from "../components/el-input.vue";
import ElPassword from "../components/el-password.vue";

// import { validate } from "../models/validation/espressoValidation";
import { User } from "../models/user.entity";
import { UserService } from "../models/user.service";
import { elValidate } from "../models/validation/espressoValidation";

const VueScrollTo = require("vue-scrollto");

@Component({
	name: "signup-professionals",
	components: {
		MainHeader,
		MainFooter,
		ElInput,
		ElPassword,
	},
})
export default class SignupProfessionals extends Vue {
	private userInfo: User = new User();

	private validationErrors = [];

	private acceptedTerms = false;

	mounted() {
		setTimeout(() => VueScrollTo.scrollTo(".main-header"), 500);
	}

	async onSubmit() {
		this.validationErrors = await elValidate(this.userInfo, { groups: ["signup"] });
		if (!this.validationErrors.length) {
			return this.signup();
		}
		this.$swal({ icon: "error", title: "Falha de validação", text: "Preencha os campos corretamente." });
		return null;
	}

	hasError(property) {
		const propertyError = this.validationErrors.find(err => err.property === property);
		return propertyError ? propertyError.error : null;
	}

	async signup() {
		try {
			const response = await UserService.signup({
				email: this.userInfo.email,
				password: this.userInfo.password,
			});
			this.$swal({ icon: "info", title: "Acesso criado", text: "Complete seu cadastro para entrar no processo seletivo" });
			this.$router.push(`/${this.$i18n.locale}/editar`);
		} catch (error) {
			console.error(error);
			if (error.error === "Conflict") {
				this.$swal({ icon: "error", title: "E-mail existente", text: "Seu e-mail já está cadastrado na plataforma" });
			} else {
				this.$swal({ icon: "error", title: "Ocorreu um erro", text: "Tente novamente mais tarde" });
			}
		}
	}
}
